'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var d = 'M24,0 C37.2280889,0 48,10.7719111 48,24 C48,37.2280889 37.2280889,48 24,48 C10.7719111,48 0,37.2280889 0,24 C0,10.7719111 10.7719111,0 24,0 Z M24,3 C12.4184,3 3,12.4184 3,24 C3,35.5816 12.4184,45 24,45 C35.5816,45 45,35.5816 45,24 C45,12.4184 35.5816,3 24,3 Z M31.8,14.25 L33.75,16.2 L25.95,24 L33.75,31.8 L31.8,33.75 L24,25.95 L16.2,33.75 L14.25,31.8 L22.05,24 L14.25,16.2 L16.2,14.25 L24,22.05 L31.8,14.25 Z';

exports["default"] = d;
